import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { SuiteShellProvider } from '@levelup/ui-shell';
import '@levelup/ui-shell/styles.css';
import App from './App';
import { store } from './store';
import { beheardShellAdapter } from './shell/beheardShellAdapter';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <SuiteShellProvider adapter={beheardShellAdapter}>
            <App />
            <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
          </SuiteShellProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
